import { baseApi } from "@/services/base.service";
import { whatsappAPI } from "@/services/whatsapp.service";
import { modesAPI } from "@/services/modes.service";
import { pedidosOracaoPublicAPI } from "@/services/pedidos-oracao-public.service";
import { ecommerceApi } from "@/services/ecommerce.service";
import { ensinoEadAPI } from "@/services/ensino-ead.service";
import { ensinoDuvidasAPI } from "@/services/ensino-duvidas.service";
import { ensinoFechamentoAPI } from "@/services/ensino-fechamento.service";
import { bibliaApi } from "@/services/biblia.service";
import "@/services/ministerio.service";
import { configureStore, Middleware } from "@reduxjs/toolkit";
import { authAPI } from "../services/auth.service";
import { eventosTrialAPI } from "../services/eventos-trial.service";
import { authReducer } from "./slices/auth.slice";
import {
  configuracoesListenerMiddleware,
  configuracoesReducer,
} from "./slices/configuracoes.slice";
import {
  eventosListenerMiddleware,
  eventosReducer,
} from "./slices/eventos.slice";
import { pequenosGruposReducer } from "./slices/pequenos-grupos.slice";
import {
  generalListenerMiddleware,
  generalReducer,
} from "./slices/general.slice";
import { inscricoesReducer } from "./slices/inscricoes.slice";
import { loginMiddleware, loginReducer } from "./slices/login.slice";
import { sheetReducer } from "./slices/sheet.slice";
import modalReducer from "./slices/modal.slice";
import checkinModeReducer from "./slices/checkin-mode.slice";
import eventoModeReducer from "./slices/evento-mode.slice";
import { eventoModeMiddleware } from "./middleware/evento-mode.middleware";
import menuReducer from "./slices/menu.slice";
import favoritosReducer from "./slices/favoritos.slice";
import { performanceReducer } from "./slices/performance.slice";

const loggerMiddleware = (store) => (next) => (action) => {
  console.log("[REDUX][ACTION]", action);
  const result = next(action);
  console.log("[REDUX][STATE]", store.getState());
  return result;
};

export const store = configureStore({
  reducer: {
    authReducer,
    configuracoesReducer,
    generalReducer,
    eventosReducer,
    pequenosGruposReducer,
    inscricoesReducer,
    loginReducer,
    sheetReducer,
    modal: modalReducer,
    checkinMode: checkinModeReducer,
    eventoMode: eventoModeReducer,
    menu: menuReducer,
    favoritos: favoritosReducer,
    performanceReducer,
    [whatsappAPI.reducerPath]: whatsappAPI.reducer,
    [authAPI.reducerPath]: authAPI.reducer,
    [eventosTrialAPI.reducerPath]: eventosTrialAPI.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [modesAPI.reducerPath]: modesAPI.reducer,
    [pedidosOracaoPublicAPI.reducerPath]: pedidosOracaoPublicAPI.reducer,
    [ecommerceApi.reducerPath]: ecommerceApi.reducer,
    [ensinoEadAPI.reducerPath]: ensinoEadAPI.reducer,
    [ensinoDuvidasAPI.reducerPath]: ensinoDuvidasAPI.reducer,
    [ensinoFechamentoAPI.reducerPath]: ensinoFechamentoAPI.reducer,
    [bibliaApi.reducerPath]: bibliaApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .prepend(generalListenerMiddleware.middleware as Middleware)
      .prepend(eventosListenerMiddleware.middleware as Middleware)
      .prepend(eventoModeMiddleware as Middleware)
      .prepend(loginMiddleware.middleware as Middleware)
      .prepend(configuracoesListenerMiddleware.middleware as Middleware)
      .concat([
        whatsappAPI.middleware,
        authAPI.middleware,
        eventosTrialAPI.middleware,
        baseApi.middleware,
        modesAPI.middleware,
        pedidosOracaoPublicAPI.middleware,
        ecommerceApi.middleware,
        ensinoEadAPI.middleware,
        ensinoDuvidasAPI.middleware,
        ensinoFechamentoAPI.middleware,
        bibliaApi.middleware,
      ] as Middleware[]),
  // .concat(loggerMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const mutationPending = (mutationName: string) =>
  Object.values(store.getState()["baseAPI"].mutations).some(
    (mutation) =>
      mutation.endpointName == mutationName && mutation.status === "pending"
  );
